/* System defined core library */
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
import { Observable, Observer, Subscription, forkJoin } from 'rxjs';

/* User defined library/components */
import { MaxLengthClass } from '../../../../shared/baseclass/max-length.class';
import { DateTimeService } from '../../../../shared/services/date-time.service';
import { RoutingService } from '../../../../shared/services/routing.service';
import { UtilityService } from '../../../../shared/services/utility.service';
import { MessagingApiService } from '../../../shared/services/messaging-api.service';
import { MetricApiService } from '../../../shared/services/metric-api.service';
import { RegistrationApiService } from '../../../shared/services/registration-api.service';
import { SchedulingApiService } from '../../../shared/services/scheduling-api.service';
import { SelectedExamDetailService } from '../../../shared/services/selected-exam-detail.service';
import { AppointmentService } from '../../services/appointment/appointment.service';
import { AppointmentLookupFormComponent } from '../appointment-lookup-form/appointment-lookup-form.component';

/* User defined models */
import { Dictionary, EmailResponse } from '../../../../shared/models/common/shared.model';
import { AppointmentDetail } from '../../../../shared/models/scheduling/appointmentdetail.model';
import { AppointmentSearch } from '../../../../shared/models/scheduling/appointmentSearch.model';
import { AppointmentSlot } from '../../../../shared/models/scheduling/appointmentSlot.model';
import { BatteryConfig } from '../../../../shared/models/scheduling/batteryConfig.model';
import { Booking } from '../../../../shared/models/scheduling/booking.model';
import { Eligibility, EligibilityDetail } from '../../../../shared/models/scheduling/eligibility.model';
import { Exam } from '../../../../shared/models/scheduling/exam.model';
import { Payment } from '../../../../shared/models/scheduling/payment.model';
import { PaymentFeeDetail } from '../../../../shared/models/scheduling/recheduleFee.model';
import { PersonDetail } from '../../../../shared/models/scheduling/personalDetail.model';

/* User defined enums/constants */
import { QrPaymentCodes, TargetFlow, TransactionType } from '../../../../shared/constants/scheduling.constant';
import { Fee } from '../../../../shared/enums/scheduling.enum';

/* Images */
const expandImg = require('../../../../../../Assets/images/ExpandIcon.png');

@Component({
  selector: 'app-appointment-lookup',
  templateUrl: './appointment-lookup.component.html',
  styleUrls: ['./appointment-lookup.component.scss']
})
export class AppointmentLookupComponent extends MaxLengthClass implements OnInit {

  @ViewChild(AppointmentLookupFormComponent) appLookupForm: AppointmentLookupFormComponent;

  /* User defined private/public variables */
  public expandIcon = expandImg;
  public personDetail: PersonDetail;
  public appointmentlookupFrm: FormGroup;
  public appointmentData: AppointmentDetail[];
  public selectedAppointmentDetails: AppointmentDetail[] = [];
  public appointmentDetails: any[];
  public appFilterFrm: FormGroup;
  public verficationDetailView: boolean;
  public isSubmitted: boolean = false;
  public hasErrorOccured: boolean = false;
  public errorMessage: string = "";
  public bookingDetails: Booking;
  public appointmentDetailData: Payment[];
  public examData: any[];
  public appointmentDetailData$: Subscription;
  public appointmentSearch: AppointmentSearch;
  public booking: Booking;
  public appointmentSlot: AppointmentSlot;
  public isEmailInProgress: boolean;
  public maxlengthLastname: number;
  public eligibilityErrorOccured: boolean = false;
  public isAllExamCancelled: boolean = false;
  public isAllExamValid: boolean = true;
  public isAllExamAllowedToCancel: boolean = true;
  public selectedAll: any;
  public redirectUrl: string = "";
  public redirectText: string = 'reconfirmationComponent.termUrl';
  public programNotPublished: boolean = false;
  public linkToIWR: string = '';
  public isBack2BackRequired: boolean;
  public isRescheduleRequired: boolean;
  public showReschedule: boolean;
  public isCancelRequired: boolean;
  public sessionIndex: number;
  public consecutiveDays: boolean;

  /* Input-OutPut parameters decalartions */
  @Input() public targetFlow: string;
  @Input() public batteryConfig: BatteryConfig;
  @Input() public cancelOnly: boolean;
  @Input() public rescheduleOnly: boolean;
  @Output() public isAppointmentSelected: EventEmitter<any> = new EventEmitter();
  @Output() public emailResponse: EmailResponse;
  @Output() public appointmentDetailsData: EventEmitter<any> = new EventEmitter();
  @Output() public selectedBackToBack: EventEmitter<any> = new EventEmitter();
  @Output() public isAllExamAllowedToCancelEmit: EventEmitter<any> = new EventEmitter();
  @Output() public isAllExamValidEmit: EventEmitter<any> = new EventEmitter();
  @Output() public selectedAppointments: EventEmitter<AppointmentDetail[]> = new EventEmitter();
  @Output() public invalidScheduleMethod: EventEmitter<boolean> = new EventEmitter();
  @Output() public rescheduleNotAllowedPolicy: EventEmitter<any> = new EventEmitter();
  @Output() public ssoClientEmit: EventEmitter<boolean> = new EventEmitter()

  /* Service subscriptions */
  appointmentSearch$: Subscription;
  booking$: Subscription;
  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private apptService: AppointmentService,
    private dateTimeService: DateTimeService,
    private messagingApiService: MessagingApiService,
    private metricApiService: MetricApiService,
    private registrationApiService: RegistrationApiService,
    private routingService: RoutingService,
    private schedulingApiService: SchedulingApiService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService,
    private utilityService: UtilityService
  ) {

    super();

    this.showReschedule = this.selectedExamDetailService.showReschedule;

    this.appointmentSearch$ = selectedExamDetailService.appointmentSearch.subscribe(
      appointmentSearch => {
        this.appointmentSearch = appointmentSearch;
      });

    this.booking$ = selectedExamDetailService.booking.subscribe(
      booking => {
        this.booking = booking;
      });

    this.appointmentDetailData$ = selectedExamDetailService.appointmentDetailData.subscribe(
      appointDetailData => {
        this.appointmentDetails = appointDetailData;
      });

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });
  }

  /* Call first time on page load */
  ngOnInit() {
    this.redirectUrl = this.selectedExamDetailService.terminationUrl;
    this.emailResponse = new EmailResponse();
    this.hasErrorOccured = false;
    this.appointmentData = [];
    this.verficationDetailView = false;
    this.isSubmitted = false;

    let clientCode = this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';
    if (clientCode === 'cfa' || clientCode === 'cfad' || clientCode === 'cfas') {
      this.redirectText = 'CFA_Cancel_Term'
    }

    if (this.appointmentSearch != null && this.appointmentSearch != undefined && this.booking != null && this.booking != undefined) {
      this.getBookingDetails(this.appointmentSearch);
      this.isSubmitted = true;
    }

    if (this.targetFlow == undefined || this.targetFlow == null) {
      this.targetFlow = this.selectedExamDetailService.currentTargetFlow;
    }
    this.isEmailInProgress = false;
    this.maxlengthLastname = 4;
    this.consecutiveDays = this.selectedExamDetailService.consecutiveDays;
  }

  /* Hide the verification detaial view & show appointment search */
  closeVerificationView(): void {
    this.verficationDetailView = false;
    this.selectedExamDetailService.showVerificationDetailView = false;
    this.emailResponse = null;
  }

  /* Final booking call to get complete details based on confirmation number & last name  */
  getBookingDetails(appointmentSearch: AppointmentSearch): void {
    this.selectedExamDetailService.cancelRefundQrTransaction = undefined;
    this.schedulingApiService.getBookingDetails(appointmentSearch.confirmationNumber, appointmentSearch.lastName).subscribe({
      next: (result) => {
        this.bookingDetails = result;
        if (this.bookingDetails != undefined && this.bookingDetails != null && this.bookingDetails.id != "-1") {
          this.apptService.checkProgramForConfig(this.bookingDetails);
          this.selectedExamDetailService.setAppointmentSearch(appointmentSearch);

          this.isBack2BackRequired = this.selectedExamDetailService.isBackToBackRequired;
          this.isRescheduleRequired = this.selectedExamDetailService.rescheduleSetAttributeCode;
          this.isCancelRequired = this.selectedExamDetailService.cancelSetAttributeCode;

          let eligibility: Eligibility = new Eligibility();
          eligibility.eligibilityDetails = new Dictionary();
          eligibility.eligibilityDetails.add("ELIGIBILITY_NUMBER", this.bookingDetails.tests[0].eligibility.id);
          eligibility.eligibilityDetails.add("FIRST_NAME", this.bookingDetails.candidate.FirstName);
          eligibility.eligibilityDetails.add("LAST_NAME", this.bookingDetails.candidate.LastName);
          this.selectedExamDetailService.setEligibility(eligibility);
          this.selectedExamDetailService.SetCandidateDataSource(this.bookingDetails.candidate);
          this.selectedExamDetailService.setClient(this.bookingDetails.client);
          this.selectedExamDetailService.clientCode = this.bookingDetails.client.code;
          this.selectedExamDetailService.setBooking(this.bookingDetails);
          // get eligibility details in case of lpi
          if (this.targetFlow === TargetFlow.Lpi) {
            let temFilterDate = this.bookingDetails.tests.filter(test => test.status.toLowerCase() != 'cancelled');
            let temp = temFilterDate.map(({ sessions }) => sessions);
            let tempConfirmaString = temp.map(function (a) { return a[0].confirmationNumber; }).join('&confirmationNumber=');

            if (this.bookingDetails.tests[0].eligibility &&
              this.bookingDetails.tests[0].eligibility.id !== ''
              && this.bookingDetails.tests[0].eligibility.id !== null
            ) {
              this.registrationApiService.getEligibilityDetails(
                this.bookingDetails.tests[0].program.code, eligibility.eligibilityDetails.getPostdataUrl(eligibility.eligibilityDetails),
                tempConfirmaString).subscribe(result => {

                  let examList: Exam[] = [];
                  result.forEach((eligibilityDetail: EligibilityDetail) => {
                    examList.push(eligibilityDetail.exam);
                    let test = this.bookingDetails.tests.find(test => test.exam.id === eligibilityDetail.exam.id);
                    test.exam.testingAccommodations = eligibilityDetail.exam.testingAccommodations;
                  });
                  this.consecutiveDays = this.selectedExamDetailService.consecutiveDays = result[0].consecutiveDays;
                  this.selectedExamDetailService.maxDays = result[0].maxDays > 0 ? result[0].maxDays : 0;

                  this.isBack2BackRequired = this.selectedExamDetailService.isBackToBackRequired;
                  this.isRescheduleRequired = this.selectedExamDetailService.rescheduleSetAttributeCode;
                  this.isCancelRequired = this.selectedExamDetailService.cancelSetAttributeCode;

                  // TODO: Reset the format on multiple tests and
                  // multiple sessions in case of b2b vs multiday - MM
                  if (
                    this.bookingDetails.tests.length > 1 &&
                    !result.some((e: EligibilityDetail) => { return e.b2b }) &&
                    result[0].maxDays == 0
                  ) {
                    this.consecutiveDays = this.selectedExamDetailService.consecutiveDays = true;
                  }

                  const eliResp = examList;
                  if (!!examList && examList.length && examList[0].id !== "-1") {
                    this.examData = examList;
                    this.getAppointmentDetails(this.bookingDetails.id);
                    this.selectedExamDetailService.setEligibilityDetails(result);
                  } else if (!!examList && examList.length && examList[0].code === "ScheduleMethodError") {
                    this.invalidScheduleMethod.emit(true);
                  } else {
                    this.getAppointmentDetails(this.bookingDetails.id);
                    this.selectedExamDetailService.setEligibilityDetails(result);
                  }
                });

            } else if (this.bookingDetails.tests[0].eligibility &&
              (this.bookingDetails.tests[0].eligibility.id === '' ||
                this.bookingDetails.tests[0].eligibility.id === null)) {
              const exam = this.bookingDetails.tests[0].exam;

              this.schedulingApiService.getExamDetails(exam.id).subscribe(
                examDetails => {
                  const exams = [];
                  exams.push(examDetails);
                  this.examData = exams;

                  this.getAppointmentDetails(this.bookingDetails.id);
                });
            }

          } else {
            this.getAppointmentDetails(this.bookingDetails.id);
          }
          this.isSubmitted = true;
        }
        else {
          this.hasErrorOccured = true;
        }
        this.appLookupForm.isSubmitInProgress = false;
      },
      error: (err) => {
        this.appLookupForm.isSubmitInProgress = false;
      }
    });
  }

  /* Send email notification for confirmation & receipt. */
  email(emailto: string, emailtype: string): void {
    $(".email-list-icon").addClass('no-outline');
    this.messagingApiService.sendAllEmailsInBooking(this.appointmentData, emailto, emailtype).subscribe(resp => {
      this.emailResponse = resp;
    });
  }

  print($event: any) {
    $(".print-list-icon").addClass('no-outline');
  }

  /* Show Verfication Detail View */
  showVerficationDetailView(event: any): void {
    this.verficationDetailView = event;
    this.selectedExamDetailService.showVerificationDetailView = true;
  }

  /* Use for get other required data like test, site,slot etc. */
  getAppointmentDetails(bookingId: string): void {
    if (this.selectedExamDetailService.isSearchPerformed) {
      let examId = this.bookingDetails.tests[0].exam.id;
      // multiday
      if (this.bookingDetails.tests.length > 1 && this.bookingDetails.tests.every(test => test.exam.id === examId)) {
        let tempAppointmentDetail: AppointmentDetail;
        tempAppointmentDetail = this.apptService.getAppointmentDetails(this.bookingDetails);

        let slotTasks$: Observable<any>[] = [];
        tempAppointmentDetail.exam.sessions.forEach((session, index) => {
          slotTasks$.push(this.getSlotData(tempAppointmentDetail, session.hold.uri, index))
        })
        forkJoin(slotTasks$).subscribe(() => {
          if (this.bookingDetails.payments.length) {
            this.schedulingApiService.getAppointmentDetails(this.bookingDetails.id).subscribe(paymentDetails => {
              this.appointmentDetails = paymentDetails;
              // To show close button in case of all exam status will cancel.
              if (!this.bookingDetails.tests.filter((tempTest) => tempTest.status.toLowerCase() != 'cancelled').length) {
                this.isAllExamCancelled = true;
              }
              tempAppointmentDetail = this.apptService.setPaymentDetailsOnAppointment(paymentDetails, tempAppointmentDetail);
              if (this.consecutiveDays || this.cancelOnly) {
                this.selectAppointment(tempAppointmentDetail);
              }
              this.setAppointmentData(this.bookingDetails, tempAppointmentDetail, null);
            });
          } else {
            if (this.consecutiveDays || this.cancelOnly) {
              this.selectAppointment(tempAppointmentDetail);
            }
            this.setAppointmentData(this.bookingDetails, tempAppointmentDetail, null);
          }
        })

      } else {
        this.bookingDetails.tests.forEach(test => {
          let tempAppointmentDetail: AppointmentDetail = new AppointmentDetail();
          tempAppointmentDetail = this.apptService.setTempApptDetail(test, this.bookingDetails);
          this.getSlotData(tempAppointmentDetail, test.sessions[0].hold.href, null).subscribe(() => { });
        });
      }
    } else {
      // TODO: add error handling
    }
  }

  getSlotData(tempAppointmentDetail: AppointmentDetail, href: string, index?: number) {
    return new Observable((observer: Observer<any>) => {
      this.schedulingApiService.getAppointmentSlot(href).subscribe((appointmentSlot) => {
        tempAppointmentDetail = this.dateTimeService.setAppointmentSlotTimes(
          appointmentSlot,
          index,
          tempAppointmentDetail,
          this.selectedExamDetailService.timeFormat
        );

        if (this.targetFlow == 'Lpi') {
          if (tempAppointmentDetail.status != 'cancelled' && tempAppointmentDetail.exam != undefined && tempAppointmentDetail.exam != undefined) {
            tempAppointmentDetail.exam.setDatesFromArray(this.examData);
          }

          this.eligibilityErrorOccured = this.apptService.checkForEligibilityError(
            this.bookingDetails,
            this.eligibilityErrorOccured,
            this.examData
          );
        }
        else { // Cancel Flow
          this.eligibilityErrorOccured = false;
        }

        if (this.bookingDetails.payments.length && !tempAppointmentDetail.exam.sessions) {
          this.schedulingApiService.getAppointmentDetails(this.bookingDetails.id).subscribe(paymentDetails => {
            this.appointmentDetails = paymentDetails;
            // To show close button in case of all exam status will cancel.
            this.isAllExamCancelled = this.apptService.checkForAllExamsCanceled(this.bookingDetails);

            tempAppointmentDetail = this.apptService.setPaymentDetailsOnAppointment(paymentDetails, tempAppointmentDetail);
            this.setAppointmentData(this.bookingDetails, tempAppointmentDetail, appointmentSlot);
          });
        } else if (!tempAppointmentDetail.exam.sessions) {
          this.setAppointmentData(this.bookingDetails, tempAppointmentDetail, appointmentSlot);
        }
        observer.next(null);
        observer.complete();
      });
    });
  }

  getApptDetail(appointmentDetail: AppointmentDetail, sessionIndex: number) {
    return this.apptService.getApptDetail(appointmentDetail, sessionIndex);
  }

  /* Finally set all appointment details of booking in shared service */
  setAppointmentData(bookingDetails: Booking, tempAppointmentDetail: AppointmentDetail, appointmentSlot?: AppointmentSlot): void {
    if (appointmentSlot && appointmentSlot.duration) {
      tempAppointmentDetail.exam.duration = appointmentSlot.duration;
    }
    this.appointmentData.push(tempAppointmentDetail);
    this.selectedExamDetailService.SetAppointmentDetail(this.appointmentData);
    if (!this.rescheduleOnly) {
      this.selectedExamDetailService.setSelectedAppointmentDetails(this.appointmentData);
    }
    this.appointmentDetailsData.emit(this.appointmentData);

    //check reschedule policy
    this.rescheduleNotAllowedPolicy.emit(this.apptService.checkForReschedulePolicyError(
      this.selectedAppointmentDetails,
      this.isRescheduleRequired,
      this.consecutiveDays,
      this.showReschedule
    ));

    const apptData = JSON.parse(JSON.stringify(this.appointmentData)); // deepclone
    this.selectedExamDetailService.setScheduledExams(apptData);

    // check if exams are in past
    let checkIfExamsValid = [true];
    if (this.appointmentData[0].exam.sessions && this.appointmentData[0].exam.sessions.length) {
      checkIfExamsValid = this.appointmentData[0].exam.sessions.map((apt) => this.dateTimeService.compareDate(apt.slot.startDateTime))
    } else {
      checkIfExamsValid = this.appointmentData.map((apt) => this.dateTimeService.compareDate(apt.appointmentSlot.startDateTime));
    }

    this.isAllExamValid = checkIfExamsValid.every((opt) => opt == true);
    this.isAllExamValidEmit.emit(this.isAllExamValid);

    let checkIfExamValidToCancel = [true];

    if (this.appointmentData[0].exam.sessions && this.appointmentData[0].exam.sessions.length) {
      checkIfExamValidToCancel = this.appointmentData[0].exam.sessions.map(session => this.dateTimeService.validDateToCancel(session.slot.startDateTime, this.targetFlow));
    } else {
      // check if candidate is trying to cancel the exam on same day of appointment
      checkIfExamValidToCancel = this.appointmentData.map((apt) => this.dateTimeService.validDateToCancel(apt.appointmentSlot.startDateTime, this.targetFlow));
    }
    this.isAllExamAllowedToCancel = checkIfExamValidToCancel.every((opt) => opt == true);
    this.isAllExamAllowedToCancelEmit.emit(this.isAllExamAllowedToCancel);


    // check if eligibility error occured
    if (this.eligibilityErrorOccured) {
      this.isAllExamValid = !this.eligibilityErrorOccured;
      this.isAllExamAllowedToCancel = !this.eligibilityErrorOccured;

      this.isAllExamValidEmit.emit(this.isAllExamValid);
      this.isAllExamAllowedToCancelEmit.emit(this.isAllExamAllowedToCancel);
    }

    // In case of single exam set exam selected and checkbox with next button enabled
    if (bookingDetails.tests.length == 1 && tempAppointmentDetail.status != 'cancelled' && this.canRescheduleInFlow(tempAppointmentDetail.exam)) {
      // TODO: hack to select appt if single appt: we should this up, simplify and move methods to service to share with appointment filter - KJC
      this.selectAppointment(this.appointmentData[0], { target: { checked: true } });
    }

    // TODO: TargetFlow specificity is not required anymore. REMOVE IT.
    else if (this.isBack2BackRequired
      && (
        ((this.targetFlow === TargetFlow.Reschedule || this.targetFlow === TargetFlow.Lpi) && this.selectedExamDetailService.rescheduleSetAttributeCode)
        || ((this.targetFlow === TargetFlow.Cancel || this.targetFlow === TargetFlow.Lpi) && this.selectedExamDetailService.cancelSetAttributeCode)
      )
      && bookingDetails.tests.length > 1 && tempAppointmentDetail.status != 'cancelled'
      && this.appointmentData.length == bookingDetails.tests.length
      && this.canRescheduleB2B(this.appointmentData)) {
      this.allExamSelected(true);
    }

    this.programNotPublished = this.selectedExamDetailService.programNotPublished;

    // TODO - Talk with Sumegha/irina what to do.
    if (this.programNotPublished) {
      let prg = this.bookingDetails.tests[0].program.code;
      let confirmationNum = this.bookingDetails.tests[0].sessions[0].confirmationNumber;
      let lastName = this.bookingDetails.candidate.LastName;
      this.linkToIWR = 'https://securereg3.prometric.com/landing.aspx?' +
        'prg=' + prg + "&" + "path=reschdcancel&" + "confnum=" + confirmationNum + "&" + "lname=" + lastName;
    }

    // emit if exams are from SSO client so that Reschedule and Cancel can redirect
    if ((this.targetFlow === TargetFlow.Reschedule || this.targetFlow === TargetFlow.Cancel || this.targetFlow === TargetFlow.Lpi)) {
      this.ssoClientEmit.emit(bookingDetails.client.sso);
    }

    if (!!this.appointmentData
      && this.appointmentData.length === this.bookingDetails.tests.length
      && !!this.appointmentData[0].exam.examSet.id
      && !this.canRescheduleB2B(this.appointmentData)) {
      this.metricApiService.logExamSetModalityConflict(this.appointmentData[0].exam.examSet);
    }
  }

  /**
  * Sets selected and disabled status in a multiday appointment based on which checkbox was toggled
  * @param sessionIndex
  * @param event
  */
  selectSession(sessionIndex: number, event: any) {
    this.selectedAppointmentDetails = [];
    this.appointmentData = this.apptService.selectSession(
      this.appointmentData,
      event,
      sessionIndex
    );
    this.selectAppointment(this.appointmentData[0], event);
  }

  /* Show the verification detail view from appointment serach screen*/
  showVerificationDetailView(): void {
    this.verficationDetailView = true;
    this.selectedExamDetailService.showVerificationDetailView = true;
    this.selectedExamDetailService.appointmentCountForInfo.next(this.appointmentData.length);
  }

  /* Use to go home */
  goHome(event: any): void {
    this.routingService.homeNavigation();
  }

  /* Go to client page after appointment is scheduled. */
  goToRedirectUrl(): void {
    this.routingService.navigateToTerm();
  }

  /* on appointment selection */
  onAppointmentSelected(event: any): void {
    this.isAppointmentSelected.emit(event);
  }

  /* SelectAppointment when user select the checkbox */
  selectAppointment(appointmentdetail: AppointmentDetail, event?: any): void {
    if (event) {
      this.appointmentData.forEach(function (item: any) {
        if (appointmentdetail.ConfirmationNumber === item.ConfirmationNumber) {
          item.selected = event.target.checked;
        }
      })
      this.selectedAll = this.appointmentData.every(function (item: any) {
        return item.selected == true;
      });

      if (event.target.checked) {
        this.selectedAppointmentDetails.push(appointmentdetail);
      } else {
        this.selectedAppointmentDetails = this.selectedAppointmentDetails.filter(f => f.exam.id != appointmentdetail.exam.id);
      }
    } else {
      this.selectedAppointmentDetails.push(appointmentdetail)
    }
    if (this.selectedAppointmentDetails.length > 0) {
      this.isAppointmentSelected.emit(true);
    } else {
      this.isAppointmentSelected.emit(false);
    }
  //check if any of the selected appointments violate the reschedule policy
    this.rescheduleNotAllowedPolicy.emit(this.apptService.checkForReschedulePolicyError(
      this.selectedAppointmentDetails,
      this.isRescheduleRequired,
      this.consecutiveDays,
      this.showReschedule
    ));
    // check if payment is being processed if there's a refund on exam
    this.schedulingApiService.getBookingPaymentRefundDetail(this.booking.id, appointmentdetail.exam.id).subscribe({
      next: (response: any) => {
        if (response && response.status === 404) this.isAllExamAllowedToCancel = false;
        else if (response && response.length) {
          let appointment = this.selectedAppointmentDetails.find(appointment => appointment.exam.id === appointmentdetail.exam.id);

          const refundablePayment = appointment.payments.find((payment) => {
            return (payment.transactionType === TransactionType.Schedule);
          });

          let results = response[0];
          if (!appointment.payments.find((payment) => payment.transactionType === Fee.Refund)) {
            let tmpPayment: Payment = new Payment(
              null,
              results.currency || "USD",
              Fee.Refund,
              null, null, null,
              null, null, null,
              null, null,
              (!!refundablePayment ? refundablePayment.paymentType : null),
              results.amount
            );
            appointment.payments.push(tmpPayment);
          }

          let refundAmount = 0;

          this.selectedAppointmentDetails.forEach(appt => {
            let refund = appt.payments.find((payment) => payment.transactionType === Fee.Refund)
            refundAmount += !!refund ? refund.refund : 0;
          });

          this.selectedExamDetailService.cancelRefund = refundAmount;
          this.selectedExamDetailService.cancelRefundCurrency = results.currency;
          this.selectedExamDetailService.cancelRefundPaymentType = (!!refundablePayment ? refundablePayment.paymentType : this.selectedExamDetailService.cancelRefundPaymentType);
          if (!!refundablePayment && !!refundablePayment.paymentType && QrPaymentCodes.indexOf(refundablePayment.paymentType.toLowerCase()) !== -1) {
            this.selectedExamDetailService.cancelRefundQrTransaction = refundablePayment;
          }
        }
        this.selectedAppointments.emit(this.selectedAppointmentDetails);
        this.isAllExamAllowedToCancelEmit.emit(this.isAllExamAllowedToCancel);
      },
      error: (err) => {
        this.selectedAppointments.emit(this.selectedAppointmentDetails);
        this.isAllExamAllowedToCancel = false;
        this.isAllExamAllowedToCancelEmit.emit(this.isAllExamAllowedToCancel);
      }
    });

    if (appointmentdetail.exam && appointmentdetail.exam.startDate && appointmentdetail.exam.endDate) {
      this.selectedExamDetailService.setOverlap(this.selectedAppointmentDetails);
    }

  }

  /* Set all appintments in shared service */
  allExamSelected(event: any): void {
    this.selectedAll = event;
    this.selectedAppointmentDetails = [];
    if (event) {
      this.selectAll();
      //When all are selected check if any of the selected appointments violate the reschedule policy
      this.rescheduleNotAllowedPolicy.emit(this.apptService.checkForReschedulePolicyError(
        this.appointmentData,
        this.isRescheduleRequired,
        this.consecutiveDays,
        this.showReschedule
      ));
    } else {
      this.rescheduleNotAllowedPolicy.emit({ error: false });
    }

    if (!!this.selectedAppointmentDetails.length) {
      let examId = this.selectedAppointmentDetails[0].exam.id;
      this.schedulingApiService.getBookingPaymentRefundDetail(this.booking.id, examId).subscribe({
        next: (response: any) => {
          if (response && response.status === 404) this.isAllExamAllowedToCancel = false;
          else {
            if (response && response.length) {
              let refundAmount: number = 0;
              this.selectedAppointmentDetails.forEach((appt) => {
                const refundablePayment = appt.payments.find((payment) => {
                  return (payment.transactionType === TransactionType.Schedule);
                });

                let results = response.find((refund: PaymentFeeDetail) => {
                  return refund.id === appt.exam.id;
                });

                let tmpPayment: Payment = new Payment(
                  null,
                  results.currency || "USD",
                  Fee.Refund,
                  null, null, null,
                  null, null, null,
                  null, null,
                  (!!refundablePayment ? refundablePayment.paymentType : null),
                  results.amount
                );
                appt.payments.push(tmpPayment);
                refundAmount += tmpPayment.refund;
                this.selectedExamDetailService.cancelRefund = refundAmount;
                this.selectedExamDetailService.cancelRefundCurrency = results.currency;
                this.selectedExamDetailService.cancelRefundPaymentType = (!!refundablePayment ? refundablePayment.paymentType : this.selectedExamDetailService.cancelRefundPaymentType);
                if (!!refundablePayment && !!refundablePayment.paymentType && QrPaymentCodes.indexOf(refundablePayment.paymentType.toLowerCase()) !== -1) {
                  this.selectedExamDetailService.cancelRefundQrTransaction = refundablePayment;
                }
              });
            }
          }
          this.isAllExamAllowedToCancelEmit.emit(this.isAllExamAllowedToCancel);
        },
        error: (err) => this.isAllExamAllowedToCancel = false
      });
    }
    
    //check if you can emit isAppointmentSelected
    let emitAppts = this.appointmentData.filter(appt => this.canRescheduleInFlow(appt.exam));
    let emitObject = this.apptService.selectAllExamsInBooking(event, emitAppts);
    if (emitObject && emitObject.emitIsAppointmentSelected) {
      this.isAppointmentSelected.emit(event);
    }
    this.selectedAppointments.emit(this.selectedAppointmentDetails);
    if (this.selectedAppointmentDetails.every((appt: AppointmentDetail) => {
      return (appt.exam && appt.exam.startDate && appt.exam.endDate);
    })) {
      this.selectedExamDetailService.setOverlap(this.selectedAppointmentDetails);
    }
  }

  /* Select All checkboxes */
  selectAll() {
    for (var i = 0; i < this.appointmentData.length; i++) {
      if (this.appointmentData[i].status != 'cancelled' && this.canRescheduleInFlow(this.appointmentData[i].exam)) {
        this.appointmentData[i].selected = this.selectedAll;
        this.selectedAppointmentDetails.push(this.appointmentData[i]);
      }
    }
  }

  submittedForm($event: AppointmentSearch) {
    const appointmentSearch: AppointmentSearch = $event;
    this.appointmentData = [];
    this.hasErrorOccured = false;
    this.isSubmitted = false;
    this.invalidScheduleMethod.emit(false);
    this.selectedExamDetailService.setSelectedAppointmentDetails(null);
    this.selectedExamDetailService.SetAppointmentDetail(null);
    this.selectedExamDetailService.setOverlapsDate(null);
    this.selectedAppointmentDetails = [];
    this.selectedExamDetailService.isSearchPerformed = true;
    this.appointmentSearch = appointmentSearch;
    this.isAppointmentSelected.emit(false);
    this.allExamSelected(false);
    this.getBookingDetails(appointmentSearch);
  }

  /**
* Checkboxes should not show up if b2b required true for reschedule.
* In this case, user must select all or none (since b2b required).
* */
  isCheckBoxHidden() {
    return this.apptService.hideCheckBoxes();
  }

  /**
   * Returns the combined duration of all selected appointments or 0 if total duration is not to be displayed in that flow
   */
  get totalDuration() {
    return this.dateTimeService.getTotalDuration(this.appointmentData, this.isSubmitted, this.targetFlow);
  }

  canShowReceiptBtn(): boolean {
    return this.apptService.canShowReceiptBtn(this.appointmentData);
  }

  //check if total duration can be displayed, based on the type of exam
  canShowDuration(): boolean {
    return this.apptService.canShowDuration(this.appointmentData);
  }

  durationToStr(val: number) {
    return this.utilityService.durationToStr(val);
  }

  canReschedule(exam: Exam) {
    return this.apptService.canScheduleExamInFlow(exam);
  }

  canRescheduleInFlow(exam: Exam) {
    return this.rescheduleOnly ? this.apptService.canScheduleExamInFlow(exam) : true;
  }

  canRescheduleB2B(appointmentData: AppointmentDetail[]) {
    return this.rescheduleOnly ? this.apptService.canRescheduleSetInFlow(appointmentData) : true;
  }
}
